export default "__VITE_ASSET__BSTEr7Iu__"